import * as React from "react";
import { Button } from "components/UI/atoms";
import { INTERNAL_PATHS } from "routes/paths";
import "./index.scss";

const getAlternate = () => (
  <div className="default-alternate">
    <p>
      Sorry, there was a problem displaying your content. Please try again
      later.
    </p>
    <Button
      size="small"
      href={INTERNAL_PATHS.HOME}
      kind="secondary"
      customClassName="back-home"
    >
      Go back to the home
    </Button>
  </div>
);

/**
 * @namespace ErrorBoundary
 */

class ErrorBoundary extends React.Component {
  static defaultProps = {
    onError: () => {}
  };

  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  componentDidCatch(error) {
    this.props.onError(error);
    this.setState({ hasError: true });
  }

  render() {
    const { alternate } = this.props;
    if (this.state.hasError) {
      return alternate || getAlternate();
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
